import { DOCUMENT } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { AppService } from './app.service';
import { httpOptions } from "../constants/http-options.constant";

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  private _http = inject(HttpClient);
  private _appService = inject(AppService);

  private suiteUrl = this._appService.getServerBaseUrl + '/suite';
  private amSuiteUrl = this._appService.getServerBaseUrl + '/amsuite';
  public serviceUrl = this._appService.getServerBaseUrl + '/auth';
  public partyUrl = this._appService.getServerBaseUrl + '/party';
  public dialogUrl = this._appService.getServerBaseUrl + '/dialog';

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() { }

  //#region Retrive datas

  getAppWidgets(appId: any): Observable<any> {
    const url = `${this.amSuiteUrl}/dashboardwidgets?appId=${appId}`;
    return this._http.get(url, httpOptions)
  }

  getUserDashboards(): Observable<any> {
    const url = `${this.amSuiteUrl}/amdashboards`;
    return this._http.get(url, httpOptions)
  }

  getUserDashboard(idDashboard: any): Observable<any> {
    const url = `${this.amSuiteUrl}/userdashboard?idDashboard=${idDashboard}`;
    return this._http.get(url, httpOptions)
  }

  getDialogRequestTypologyes(): Observable<any> {
    const url = `${this.dialogUrl}/types`;
    return this._http.get(url, httpOptions)
  }

  //#endregion

  //#region Operations

  createDashboard(appId: any): Observable<any> {
    const url = `${this.amSuiteUrl}/createdashboard?appId=${appId}`;
    return this._http.get(url, httpOptions)
  }

  duplicateDashboard(dashboard: any): Observable<any> {
    const url = `${this.amSuiteUrl}/duplicatedashboard`;
    return this._http.post(url, dashboard, httpOptions)
  }

  saveDashboard(dashboard: any): Observable<any> {
    const url = `${this.amSuiteUrl}/savedashboard`;
    return this._http.put(url, dashboard, httpOptions)
  }

  removeDashboard(dashboardId: any): Observable<any> {
    const url = `${this.amSuiteUrl}/removedashboard?dashboardId=${dashboardId}`;
    return this._http.delete(url, httpOptions)
  }

  defaultDashboard(dashboardId: any): Observable<any> {
    const url = `${this.amSuiteUrl}/defaultdashboard?dashboardId=${dashboardId}`;
    return this._http.get(url, httpOptions);
  }

  //#endregion

}
